module.exports = __webpack_public_path__ + "img/tvcg23dminer.57c56742.png";